import { render } from "./VoucherDetailModal.vue?vue&type=template&id=2556c742&scoped=true"
import script from "./VoucherDetailModal.vue?vue&type=script&lang=js"
export * from "./VoucherDetailModal.vue?vue&type=script&lang=js"

import "./VoucherDetailModal.vue?vue&type=style&index=0&id=2556c742&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2556c742"]])

export default __exports__